<h6 *ngIf="props.showTitle" class="b-f-fileuploadbox-title">
  {{ props.title ? props.title : defaultTitle }}
</h6>
<div *ngIf="props.showProfileImageExample" class="b-f-fileuploadbox-example">
  <div class="b-f-fileuploadbox-example-text">Example</div>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="4" fill="#333333" />
    <path
      d="M24.9575 13.0423C18.907 12.5141 13.573 16.992 13.0423 23.0425C12.5141 29.093 16.9896 34.4294 23.0425 34.9577C29.093 35.4859 34.4294 31.0104 34.9577 24.9575C35.4859 18.907 31.0104 13.573 24.9575 13.0423ZM19.9561 31.5827C17.4274 31.3601 16.3122 29.8169 15.7692 28.8998C13.057 24.3607 14.5415 18.4814 19.0806 15.7717C20.4966 14.9279 22.1034 14.4608 23.7518 14.4217C23.6368 14.4608 22.4703 15.0967 22.3235 16.7915C22.1841 18.3836 23.1722 19.8339 23.9596 21.2352C24.1602 21.5972 24.3485 21.9322 24.5882 22.3553C25.2338 23.4974 25.9284 25.0406 25.7841 26.6987C25.5249 29.658 22.9178 31.8468 19.9586 31.59L19.9561 31.5827ZM27.3689 29.5797C27.1463 32.1109 24.9306 33.6101 22.4434 33.3924C21.8686 33.3411 21.3037 33.2164 20.7608 33.0183C23.8667 32.8617 26.4713 30.6215 27.0925 27.5743C27.3322 28.2126 27.4276 28.8998 27.3664 29.5797H27.3689ZM33.5465 24.8303C33.4732 25.6863 33.2848 26.5276 32.984 27.3322C33.1014 25.9333 32.5805 22.7221 29.5968 20.3425C29.3963 20.1811 28.868 19.7629 28.4694 19.4426C27.0045 18.276 25.8501 17.5398 25.9504 16.3953C26.0164 15.6934 26.6376 15.1798 27.3395 15.2458C27.3542 15.2458 27.3689 15.2483 27.3835 15.2507C28.7824 15.373 30.2889 16.7695 30.2889 16.7695C32.5976 18.7847 33.8058 21.7781 33.5465 24.8303Z"
      fill="white"
    />
  </svg>
</div>
<ng-container>
  <div
    *ngIf="props.showBackgroundImageExample"
    class="b-f-fileuploadbox-example"
  >
    <div class="b-f-fileuploadbox-example-text">Background Image Example</div>
    <div class="background-image image-border-radius">
      <i (click)="openImageInNew()" class="symbol-open-in-new"></i>
    </div>
  </div>
  <div
    *ngIf="props.showOrganizationLogoExample"
    class="b-f-fileuploadbox-example"
  >
    <div class="b-f-fileuploadbox-example-text">Organization Logo Example</div>
    <div class="logo-example image-border-radius"></div>
  </div>
  <div
    *ngIf="props.showApplicationLogoExample"
    class="b-f-fileuploadbox-example"
  >
    <div class="b-f-fileuploadbox-example-text">Application Logo Example</div>
    <div class="logo-example image-border-radius"></div>
  </div>
</ng-container>
<div *ngIf="props.showSubtitle" class="b-f-fileuploadbox-example-text">
  {{ props.subtitle ? props.subtitle : defaultSubtitle }}
</div>
<div
  *ngIf="props.showAcceptedFileTypes"
  class="b-f-fileuploadbox-acceptedtype-text"
>
  Accepted File Type:
  {{
    props.acceptedFileTypes
      ? props.acceptedFileTypes
      : defaultAcceptedFileTypesDisplay
  }}
</div>
<div
  *ngIf="props.showUploadMessageDetails"
  class="b-f-fileuploadbox-details-text"
>
  {{
    props.uploadMessageDetails
      ? props.uploadMessageDetails
      : defaultUploadMessageDetails
  }}
</div>
<div class="b-f-fileuploadbox-file-selection">
  <ul style="list-style-type: none" *ngIf="uploadedFiles.length">
    <li
      class="file-line-container"
      *ngFor="let file of uploadedFiles; let i = index"
    >
      <div class="file-icon-and-name">
        <div
          class="symbol-check-circle-outline file-icon"
          *ngIf="file?.hasUploaded"
        ></div>
        <p-progressSpinner
          class="b-f-fileuploadbox-fileprogressspinner"
          styleClass="file-upload-spinner"
          strokeWidth="2"
          animationDuration="0.5s"
          *ngIf="file?.uploadInProgress"
        ></p-progressSpinner>
        <div class="basin-subtitle-small file-name">{{ file.name }}</div>
      </div>
      <div
        class="symbol-delete file-delete"
        *ngIf="props.canRemove ? props.canRemove : true"
        (click)="deleteFile(i)"
      ></div>
    </li>
  </ul>
</div>
<div
  id="drop_zone"
  (dragover)="dragOverHandler($event)"
  (dragleave)="dragLeaveHandler($event)"
  (drop)="dropHandler($event)"
  class="b-f-fileuploadbox-fileform"
  [ngClass]="{ dragover: dragover }"
>
  <input
    #fileUpload
    type="file"
    style="display: none"
    [accept]="
      props.acceptedFileTypes
        ? props.acceptedFileTypes
        : defaultAcceptedFileTypes
    "
    [multiple]="props.multiple ? props.multiple : defaultMultiple"
    (change)="uploadFile($event)"
    [id]="field.id"
    [name]="field.id"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [required]="props.required"
  />
  <div class="b-f-fileuploadbox-fileform-contents">
    <div class="b-f-fileuploadbox-uploadprompt">
      <span
        class="b-f-fileuploadbox-uploadprompt-icon symbol-cloud-upload"
      ></span>
      <span class="b-f-fileuploadbox-uploadprompt-text">
        {{ props.placeholder ? props.placeholder : defaultPlaceholder }}
      </span>
    </div>
    <span
      ><p-button
        type="button"
        (click)="fileUpload.click()"
        styleClass="p-button-sm"
        label="BROWSE"
        icon="symbol-add"
      >
      </p-button
    ></span>
  </div>
</div>
<div
  *ngIf="
    props.required && field.formControl.touched && !field.formControl.valid
  "
  class="b-f-fileuploadbox-requiredmessage"
>
  <small> This field is required. </small>
</div>
